import { render, staticRenderFns } from "./PageBackgroundImage.vue?vue&type=template&id=74b2743a&scoped=true&"
import script from "./PageBackgroundImage.vue?vue&type=script&lang=js&"
export * from "./PageBackgroundImage.vue?vue&type=script&lang=js&"
import style0 from "./PageBackgroundImage.vue?vue&type=style&index=0&id=74b2743a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b2743a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74b2743a')) {
      api.createRecord('74b2743a', component.options)
    } else {
      api.reload('74b2743a', component.options)
    }
    module.hot.accept("./PageBackgroundImage.vue?vue&type=template&id=74b2743a&scoped=true&", function () {
      api.rerender('74b2743a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/LeaderBoard/components/PageBackgroundImage.vue"
export default component.exports